module.exports = __webpack_public_path__ + "static/media/29170009-min.8e3d698a.jpg";